import React from 'react'
import DocumentTitle from 'react-document-title'
import { PageNavLinks, PageTitle } from '@Root/components'
import { getCurrentLink } from '@Root/helpers'
import { useLocation } from 'react-router'
import { pagesLinksForms } from '@Root/configs'
import { Forms } from '@Root/modules/Forms/Forms'
import { Switch, Route, Redirect } from 'react-router-dom'
import { DetailsCognitoForms } from '@Root/modules/Forms/DetailsCognitoForms'
import { RawSubmissionData } from '@Root/modules/Forms/RawSubmissionData'
import { MappingsCognitoForms } from '@Root/modules/Forms/MappingsCognitoForms'
import { FormEmails } from '@Root/modules/Forms/FormEmails'

export const FormsPage = () => {
  const location = useLocation()
  const currentLink = getCurrentLink(pagesLinksForms, location)
  const styleConfig = {
    navLinksStyles: {
      position: 'fixed',
      width: '100%',
      top: '115px',
      right: 0,
      zIndex: 10,
      padding: '0 10px',
    },
    pageTitle: {
      position: 'fixed',
      top: 0,
      zIndex: 10,
      marginTop: 50,
    },
  }

  return (
    <DocumentTitle title={`Forms`}>
      <div>
        <PageTitle title={currentLink.name} style={styleConfig.pageTitle} />
        <Switch>
          <Route path='/home/forms/:id/details/:submissionId' component={RawSubmissionData} />
          <Route path='/home/forms/:id/mappings' component={MappingsCognitoForms} />
          <Route path='/home/forms/:id/emails' component={FormEmails} />
          <Route path='/home/forms/:id' component={DetailsCognitoForms} />
          <Route path='/' component={Forms} />
          <Redirect to='/home/forms' />
        </Switch>
      </div>
    </DocumentTitle>
  )
}
